import { Component, ElementRef, Input, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalDialogComponent implements OnInit {
  constructor(private element: ElementRef) {}

  @Input() dialogTemplate: TemplateRef<null>

  displayed = false
  public loading = false

  ngOnInit() {}

  open(): void {
    this.loading = false
    this.displayed = true
  }

  close() {
    this.loading = false
    this.displayed = false
  }

  get isOpen() {
    return this.displayed
  }
}
